import { render, staticRenderFns } from "./CmgDeliveryOffline.vue?vue&type=template&id=2a3cb911&scoped=true&lang=pug"
import script from "./cmg-delivery-offline.ts?vue&type=script&lang=ts&external"
export * from "./cmg-delivery-offline.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgDeliveryOffline.vue?vue&type=style&index=0&id=2a3cb911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3cb911",
  null
  
)

export default component.exports